import React, { useEffect } from "react";
import "./termsConditions.css";
import { Helmet } from "react-helmet";


export default function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>SHOP.CO | Terms & Conditions</title>
        <meta
          name="description"
          content="Read SHOP.CO’s terms and conditions to understand our policies on shopping, payments, returns, and user responsibilities."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/help/terms-conditions/"
        />

      </Helmet>
      <div className="terms-container">
        <header className="terms-header">
          <h1>Terms & Conditions</h1>
          <p>Please read these terms carefully before using our website.</p>
        </header>

        <section className="terms-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to our online store. By accessing or using our site, you agree to be bound by these terms and conditions. If you disagree with any part of these terms, please do not use our services.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Orders</h2>
          <p>
            All orders are subject to availability and confirmation of the order price. We reserve the right to refuse any order at our discretion.
          </p>
        </section>

        <section className="terms-section">
          <h2>3. Pricing & Payment</h2>
          <p>
            Prices for our products are subject to change without notice. We accept multiple payment methods including credit cards and COD (where applicable).
          </p>
        </section>

        <section className="terms-section">
          <h2>4. Shipping</h2>
          <p>
            Shipping times may vary based on your location and selected delivery method. Delays may occur due to customs or external conditions.
          </p>
        </section>

        <section className="terms-section">
          <h2>5. Returns & Refunds</h2>
          <p>
            Items can be returned within 7 days of delivery. Refunds will be processed after inspection and approval. See our Return Policy for more details.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. Privacy Policy</h2>
          <p>
            Your personal data is protected. We never share your information with third parties without your consent. Read our full Privacy Policy for more.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. Changes to Terms</h2>
          <p>
            We reserve the right to update or modify these terms at any time. It is your responsibility to check this page periodically for changes.
          </p>
        </section>

        <footer className="terms-footer">
          <p>Last Updated: July 2025</p>
        </footer>
      </div>
    </>
  );
}
